import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(16,42,66,0.09)] dark:border-[rgba(214,233,247,0.09)] mt-auto">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-[2fr_1fr_1fr_1fr] gap-6 md:gap-12 mb-7">
          <div>
            <Logo />
            <p className="text-text-secondary text-sm mt-4 max-w-[300px] leading-relaxed">
              New Zealand's marine industry directory. Connecting boaties, sailors and marine businesses across Aotearoa, from charters and chandlery to Sealegs service, marinas and marine engineering.
            </p>
          </div>
          <div>
            <h4 className="text-[0.65rem] sm:text-xs font-semibold uppercase tracking-wider text-text-muted mb-3 sm:mb-4">Browse</h4>
            <ul className="flex flex-col gap-2 sm:gap-3">
              <li><Link to="/categories" className="text-sm text-text-secondary hover:text-accent transition-colors">All categories</Link></li>
              <li><Link to="/regions" className="text-sm text-text-secondary hover:text-accent transition-colors">By region</Link></li>
              <li><Link to="/browse" className="text-sm text-text-secondary hover:text-accent transition-colors">Featured</Link></li>
              <li><Link to="/browse" className="text-sm text-text-secondary hover:text-accent transition-colors">Boats for sale</Link></li>
              <li><Link to="/news" className="text-sm text-text-secondary hover:text-accent transition-colors">Marine News</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[0.65rem] sm:text-xs font-semibold uppercase tracking-wider text-text-muted mb-3 sm:mb-4">Business</h4>
            <ul className="flex flex-col gap-2 sm:gap-3">
              <li><Link to="/list" className="text-sm text-text-secondary hover:text-accent transition-colors">List your business</Link></li>
              <li><Link to="/pricing" className="text-sm text-text-secondary hover:text-accent transition-colors">Pricing</Link></li>
              <li><Link to="/pricing#plans" className="text-sm text-text-secondary hover:text-accent transition-colors">Premium features</Link></li>
              <li><Link to="/pricing#advertising" className="text-sm text-text-secondary hover:text-accent transition-colors">Advertising</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[0.65rem] sm:text-xs font-semibold uppercase tracking-wider text-text-muted mb-3 sm:mb-4">Company</h4>
            <ul className="flex flex-col gap-2 sm:gap-3">
              <li><Link to="/about" className="text-sm text-text-secondary hover:text-accent transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-sm text-text-secondary hover:text-accent transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="text-sm text-text-secondary hover:text-accent transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="text-sm text-text-secondary hover:text-accent transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-3 pt-6 border-t border-[rgba(16,42,66,0.09)] dark:border-[rgba(214,233,247,0.09)] text-xs text-text-muted">
          <span className="text-center md:text-left">© 2026 MarineLink Co NZ. All rights reserved.</span>
          <span className="flex flex-col sm:flex-row items-center gap-1 sm:gap-4 text-center md:text-left">
            <span>Crafted in Auckland, New Zealand</span>
            <span>Web directory and web hosting by <a href="https://wasabi.digital" target="_blank" rel="noopener noreferrer" className="font-medium text-text-secondary hover:text-accent transition-colors">Wasabi Digital</a></span>
          </span>
        </div>
      </div>
    </footer>
  );
}